module.exports = __webpack_public_path__ + "img/eatDoradoText.9dde2e90.png";